// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"c96a8710","113":"d12938f4","242":"8531c565","453":"73888686","591":"e33a0ef4","754":"bf7f1a00","801":"c435b1bd","900":"9c327392","930":"bea47682"}[chunkId] + ".chunk.js";
};